/* eslint-disable import/no-anonymous-default-export */
const toString62 = function (num) {
  let res = '';
  let str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  do {
    let rem = num % 62;
    num = Math.floor(num / 62);
    let z = str.substr(rem, 1);
    res = `${z}${res}`;
  }
  while (num > 0);
  return res;
};

const toString36 = function (num) {
  let res = '';
  let str = '0123456789abcdefghijklmnopqrstuvwxyz';
  do {
    let rem = num % 36;
    num = Math.floor(num / 36);
    let z = str.substr(rem, 1);
    res = `${z}${res}`;
  }
  while (num > 0);
  return res;
};
function formatNum(num, decimalPlaces = 2) {
  // let str = num.toFixed(decimalPlaces);
  // 使用正则表达式去除末尾的0和.0
  // return str.replace(/(\.\d*[1-9])0*$/, '$1').replace(/\.$/, '');
  return Math.round(num * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
}
const changx = function (str, sort = 2) {
  let res = '';
  let arra = str.split('');
  arra.map((item, index) => {
    if (index < sort) {
      res += item;
    } else {
      res += '*';
    }
  })
  return res;
}
export default {
  toString62: toString62,
  toString36: toString36,
  formatNum: formatNum,
  changx: changx,
};